"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            TaskRecorder_ContextMenuAddInfoStep: "Add info step",
            TaskRecorder_ContextMenuCopiedValuePlaceholder: "{0} : {1}",
            TaskRecorder_ContextMenuCopy: "Copy",
            TaskRecorder_ContextMenuCurrentValue: "Current Value",
            TaskRecorder_ContextMenuPaste: "Paste",
            TaskRecorder_ContextMenuValidate: "Validate",
            TaskRecorder_ContextMenuValidateAllowEditMode: "Editable",
            TaskRecorder_ContextMenuValidateDisabled: "Disabled",
            TaskRecorder_ContextMenuValidateEnabled: "Enabled",
            TaskRecorder_ContextMenuValidateReadOnlyMode: "Read-only",
            TaskRecorder_PaneTitle: "Task recorder"
        }
    });
    var ax;
    (function (ax) {
        /** Contains Task Recorder pane helpers, Task Recorder toolbar helper, and Task Recored context menu functionality. */
        var taskRecording;
        (function (taskRecording) {
            var Actions;
            (function (Actions) {
                Actions["Pause"] = "Pause";
                Actions["Resume"] = "Resume";
                Actions["Start"] = "Start";
                Actions["Stop"] = "Stop";
                Actions["Validation"] = "Validation";
            })(Actions = taskRecording.Actions || (taskRecording.Actions = {}));
            /** @deprecated This is deprecated at 09/11/2020. */
            taskRecording.style = "task-recorder-button";
            taskRecording.started = $dyn.observable(false);
            taskRecording.scopeStarted = $dyn.observable(false);
            /** @deprecated This is deprecated at 09/11/2020. */
            taskRecording.paneName = "SysTaskRecorderPane";
            taskRecording.taskRecorderController = new ax.taskRecorder.Controller();
            /** Tracks the current task context */
            taskRecording.currentTask = $dyn.observable();
            /** Indicates recording state (true for usual recording, playback, and Task Guides). */
            taskRecording.isRecording = $dyn.observable();
            /** Indicates task guide state. */
            taskRecording.taskGuidePlaybackState = $dyn.observable();
            /** Indicates rails mode state. */
            taskRecording.taskGuideRailsMode = $dyn.observable(false);
            /** The event to indicate whenever the task recorder context menu opens */
            taskRecording.contextMenuOpen = new $dyn.eventHost();
            taskRecording.disabledPreviewState = $dyn.flags.disablePreview;
            /** Opens the Task Recorder pane. */
            function open() {
                if (!taskRecording.pane) {
                    taskRecording.pane = {
                        back: taskRecording.close,
                        canGoBack: true,
                        name: "TaskRecorderPane",
                        role: "Dialog",
                        templateId: "TaskRecorderPane"
                    };
                    $dyn.shell.createForm(taskRecording.pane);
                    var context_1 = $dyn.context(taskRecording.pane.targetElement);
                    context_1.DisplayTarget = $dyn.forms.DisplayTarget.AsidePane;
                    // This is a singleton form, so we do not want to auto close it
                    context_1.PreventAutoClose(true);
                }
                $dyn.shell.open({ form: $dyn.context(taskRecording.pane.targetElement) });
            }
            taskRecording.open = open;
            /** Hides the Task Recorder pane. */
            function close() {
                if (taskRecording.pane) {
                    $dyn.shell.hideAsidePane(taskRecording.pane.targetElement);
                }
            }
            taskRecording.close = close;
            /**
             * Shows the pane if it is hidden or hides the pane if it is currently visible.
             * Called through the button in the Task Recorder toolbar.
             */
            function togglePaneVisibility() {
                if ($dyn.value($dyn.shell.isAsidePaneOpen)) {
                    if (taskRecording.pane && taskRecording.pane.targetElement) {
                        var asidePaneContext = $dyn.context(taskRecording.pane.targetElement);
                        if (asidePaneContext) {
                            asidePaneContext.hide();
                        }
                    }
                }
                else if (!$dyn.value($dyn.shell.isAsidePaneOpen)) {
                    taskRecording.open();
                }
            }
            taskRecording.togglePaneVisibility = togglePaneVisibility;
            /**
             * Shows the task guide pane if it is hidden or hides the pane if it is currently visible.
             * Called through the TaskRecorderOpenPane shortcut.
             */
            function toggleTaskGuidePaneVisibility() {
                if ($dyn.value($dyn.shell.isAsidePaneOpen) && ($dyn.shell.getActiveAsideForm() === taskRecording.runningTaskGuidePane)) {
                    var asidePaneContext = $dyn.context(taskRecording.pane.targetElement);
                    if (asidePaneContext) {
                        asidePaneContext.hide();
                    }
                }
                else {
                    taskRecording.toolbarOpenPane();
                }
            }
            taskRecording.toggleTaskGuidePaneVisibility = toggleTaskGuidePaneVisibility;
            /**
             * Shows the task pane if it is hidden or hides the pane if it is currently visible.
             * Called through the TaskRecorderOpenPane shortcut.
             */
            function toggleTaskPaneVisibility() {
                if ($dyn.value($dyn.shell.isAsidePaneOpen) && (taskRecording.pane.name === $dyn.context($dyn.shell.getActiveAsideForm()).FormName)) {
                    var asidePaneContext = $dyn.context(taskRecording.pane.targetElement);
                    if (asidePaneContext) {
                        asidePaneContext.hide();
                    }
                }
                else {
                    taskRecording.toolbarOpenPane();
                }
            }
            taskRecording.toggleTaskPaneVisibility = toggleTaskPaneVisibility;
            /** Adds the Task Recorder toolbar. */
            function addToolbar() {
                if (taskRecording._toolbar || $dyn.shell.isTaskRecorderToolbarOpen()) {
                    // Toolbar already open
                    return;
                }
                // Create a clone of the template.
                var toolbar = taskRecording._toolbar = $($dyn._getTemplate("TaskRecorderToolbar")).clone();
                if (toolbar.length > 0) {
                    // Data bind the toolbar to the taskRecording context.
                    // any is required as taskRecording is not a control type
                    $dyn.dataBind(toolbar[0], new $dyn.DataContext(taskRecording));
                    // Insert the toolbar
                    toolbar.insertBefore($("#mainContainer"));
                    // Call reflowRootForm once animation is complete
                    // 400 is the default value
                    var animationDuration = 400;
                    if ($dyn.flags.disableAnimations) {
                        animationDuration = 0;
                    }
                    // Animate the addition of the toolbar
                    var height = toolbar.height();
                    toolbar.height(0);
                    toolbar.animate({ height: height });
                    $("#mainContainer").animate({ top: height }, animationDuration, function () {
                        $dyn.layout.reflowRootForm();
                    });
                    $dyn.shell.isTaskRecorderToolbarOpen(true);
                }
            }
            taskRecording.addToolbar = addToolbar;
            /** Removes and unbinds the Task Recorder toolbar. */
            function removeToolbar() {
                if (taskRecording._toolbar) {
                    var toolbar_1 = taskRecording._toolbar;
                    taskRecording._toolbar = null;
                    $("#mainContainer").animate({ top: 0 });
                    toolbar_1.animate({ height: 0 }, {
                        complete: function () {
                            toolbar_1.remove();
                            $dyn.unbind(toolbar_1[0]);
                            $dyn.shell.isTaskRecorderToolbarOpen(false);
                        }
                    });
                }
            }
            taskRecording.removeToolbar = removeToolbar;
            /** Handler for the toolbar open pane button (hamburger icon on the right side). */
            function toolbarOpenPane() {
                // Do we have a guide form to show?
                if (taskRecording.runningTaskGuidePane) {
                    $dyn.shell.open({ form: $dyn.context(taskRecording.runningTaskGuidePane) });
                }
                else {
                    // Open the standard task recorder pane in the recording mode
                    taskRecording.open();
                }
            }
            taskRecording.toolbarOpenPane = toolbarOpenPane;
            /**
             * Called when the stop button is clicked in the toolbar.
             * Opens the pane if it is not already open.
             */
            function stopSession() {
                taskRecording.started(false);
                if (!$dyn.value($dyn.shell.isAsidePaneOpen)) {
                    taskRecording.toolbarOpenPane();
                }
                if (taskRecording && taskRecording.taskRecorderStateControl) {
                    taskRecording.taskRecorderStateControl.stopSession();
                }
            }
            taskRecording.stopSession = stopSession;
            /** Called to animate the QTip. */
            function animatetaskGuideQTip() {
                if (taskRecording && taskRecording.taskRecorderController) {
                    taskRecording.taskRecorderController.onRailsBlocksClicked();
                }
            }
            taskRecording.animatetaskGuideQTip = animatetaskGuideQTip;
            /** Turn rails mode on. Also logs a telemetry event. */
            function SwitchRailsModeOn() {
                taskRecording.taskGuideRailsMode(true);
                $dyn.callFunction(taskRecording.taskRecorderStateControl.LogRailsModeStateChangedTelemetryEvent, taskRecording, [true]);
            }
            taskRecording.SwitchRailsModeOn = SwitchRailsModeOn;
            /** Turn rails mode off. Also logs a telemetry event. */
            function SwitchRailsModeOff() {
                taskRecording.taskGuideRailsMode(false);
                $dyn.callFunction(taskRecording.taskRecorderStateControl.LogRailsModeStateChangedTelemetryEvent, taskRecording, [false]);
            }
            taskRecording.SwitchRailsModeOff = SwitchRailsModeOff;
            /** Sets focus on the first tabable element in the task recorder pane. */
            function setTaskRecorderFocus() {
                var taskPaneElement = document.querySelector('[data-dyn-form-name="TaskRecorderPane"]');
                if (taskPaneElement) {
                    var firstControlElement = $dyn.util.findFirstFocusableControl(taskPaneElement);
                    var firstControl = $dyn.context(firstControlElement);
                    if (firstControl && firstControl.Root && firstControl.Root.setControlFocus) {
                        $dyn.log.focus && $dyn.log.focus("Focus: Shell->Shortcuts(Task recorder) set focus to the task recorder form");
                        firstControl.Root.setControlFocus(firstControl.Name);
                    }
                }
            }
            taskRecording.setTaskRecorderFocus = setTaskRecorderFocus;
            /** Sets focus on the first tabable element in the task guide pane. */
            function setTaskGuideFocus() {
                var taskPaneElement = document.querySelector('[data-dyn-form-name="SysTaskGuidePane"]');
                if (taskPaneElement) {
                    var firstControlElement = $dyn.util.findFirstFocusableControl(taskPaneElement);
                    var firstControl = $dyn.context(firstControlElement);
                    if (firstControl && firstControl.Root && firstControl.Root.setControlFocus) {
                        $dyn.log.focus && $dyn.log.focus("Focus: Shell->Shortcuts(Task recorder) set focus to the task guide pane form");
                        firstControl.Root.setControlFocus(firstControl.Name);
                    }
                }
            }
            taskRecording.setTaskGuideFocus = setTaskGuideFocus;
            /** Handles server recording state changed. */
            function _handleServerRecordingStateChanged(newState) {
                if (taskRecording._recordingState === newState) {
                    // State didn't change, no need to do anything
                    return;
                }
                // Take the new state
                taskRecording._recordingState = newState;
                var trStarted = (newState !== "NotRecording");
                // Update "started" state
                taskRecording.started(trStarted);
                taskRecording.isRecording(trStarted);
                // Handle state change logic
                if (trStarted !== true) {
                    // If we stopped, reset TR specific context menu
                    $dyn.contextMenu.setProvider(null);
                }
                else {
                    // We are starting, set a new TR context menu provider
                    var copyControlArray_1 = [];
                    $dyn.contextMenu.setProvider({
                        canShow: function () {
                            return true;
                        },
                        /** contextControl is of type any because recordability is not on all types of control */
                        prepareShow: function (list, contextControl) {
                            var e_1, _a, e_2, _b;
                            var isValidationContextMenuShouldBeVisible = function (recordabilityObject) {
                                return recordabilityObject.validate ||
                                    recordabilityObject.validateEnabled || recordabilityObject.validateDisabled ||
                                    recordabilityObject.validateAllowEditMode || recordabilityObject.validateReadOnlyMode;
                            };
                            if (contextControl) {
                                // If it's playbackmode or the form is not recordable, do not show the TR menu
                                if ($dyn.value(taskRecording.taskGuidePlaybackState) || (contextControl.Root && !$dyn.peek(contextControl.Root.Recordable))) {
                                    return;
                                }
                                var recordability_1 = contextControl.recordability && contextControl.recordability();
                                var recordOption = {
                                    contextMenuOptions: [],
                                    Enabled: recordability_1 != null,
                                    Label: $dyn.label("TaskRecorder_PaneTitle")
                                };
                                if (recordability_1) {
                                    if (recordability_1.copy) {
                                        var copyOption = {
                                            Command: function () {
                                                $dyn.callFunction(recordability_1.copy, contextControl, function copyCallback(bookmark) {
                                                    var copiedControl = {
                                                        ControlName: contextControl.Name,
                                                        ControlValue: bookmark.Value,
                                                        Id: bookmark.Id,
                                                        Label: bookmark.Label
                                                    };
                                                    copyControlArray_1.push(copiedControl);
                                                });
                                            },
                                            Enabled: true,
                                            Label: $dyn.label("TaskRecorder_ContextMenuCopy")
                                        };
                                        recordOption.contextMenuOptions.push(copyOption);
                                    }
                                    if (recordability_1.paste) {
                                        var pasteOption = {
                                            contextMenuOptions: [],
                                            Enabled: recordability_1 != null,
                                            Label: $dyn.label("TaskRecorder_ContextMenuPaste")
                                        };
                                        pasteOption.contextMenuOptions = [];
                                        var _loop_1 = function (copyControl) {
                                            pasteOption.contextMenuOptions.push({
                                                Command: (function () {
                                                    return function () {
                                                        $dyn.callFunction(recordability_1.paste, contextControl, copyControl.Id, copyControl.ControlValue);
                                                    };
                                                })(),
                                                Label: $dyn.format($dyn.label("TaskRecorder_ContextMenuCopiedValuePlaceholder"), copyControl.ControlName, copyControl.Label),
                                            });
                                        };
                                        try {
                                            for (var copyControlArray_2 = __values(copyControlArray_1), copyControlArray_2_1 = copyControlArray_2.next(); !copyControlArray_2_1.done; copyControlArray_2_1 = copyControlArray_2.next()) {
                                                var copyControl = copyControlArray_2_1.value;
                                                _loop_1(copyControl);
                                            }
                                        }
                                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                        finally {
                                            try {
                                                if (copyControlArray_2_1 && !copyControlArray_2_1.done && (_a = copyControlArray_2.return)) _a.call(copyControlArray_2);
                                            }
                                            finally { if (e_1) throw e_1.error; }
                                        }
                                        recordOption.contextMenuOptions.push(pasteOption);
                                    }
                                    if (isValidationContextMenuShouldBeVisible(recordability_1)) {
                                        var validateOption = {
                                            contextMenuOptions: [],
                                            Enabled: recordability_1 != null,
                                            Label: $dyn.label("TaskRecorder_ContextMenuValidate")
                                        };
                                        if (recordability_1.validate) {
                                            validateOption.contextMenuOptions.push({
                                                Command: function () {
                                                    $dyn.callFunction(recordability_1.validate, contextControl, null);
                                                },
                                                Label: $dyn.label("TaskRecorder_ContextMenuCurrentValue"),
                                            });
                                        }
                                        if (recordability_1.validateEnabled) {
                                            validateOption.contextMenuOptions.push({
                                                Command: function () {
                                                    $dyn.callFunction(recordability_1.validateEnabled, contextControl);
                                                },
                                                Label: $dyn.label("TaskRecorder_ContextMenuValidateEnabled"),
                                            });
                                        }
                                        else if (recordability_1.validateDisabled) {
                                            validateOption.contextMenuOptions.push({
                                                Command: function () {
                                                    $dyn.callFunction(recordability_1.validateDisabled, contextControl);
                                                },
                                                Label: $dyn.label("TaskRecorder_ContextMenuValidateDisabled")
                                            });
                                        }
                                        if (recordability_1.validateAllowEditMode) {
                                            validateOption.contextMenuOptions.push({
                                                Command: function () {
                                                    $dyn.callFunction(recordability_1.validateAllowEditMode, contextControl);
                                                },
                                                Label: $dyn.label("TaskRecorder_ContextMenuValidateAllowEditMode"),
                                            });
                                        }
                                        else if (recordability_1.validateReadOnlyMode) {
                                            validateOption.contextMenuOptions.push({
                                                Command: function () {
                                                    $dyn.callFunction(recordability_1.validateReadOnlyMode, contextControl);
                                                },
                                                Label: $dyn.label("TaskRecorder_ContextMenuValidateReadOnlyMode"),
                                            });
                                        }
                                        var _loop_2 = function (copyControl) {
                                            validateOption.contextMenuOptions.push({
                                                Command: (function () {
                                                    return function () {
                                                        $dyn.callFunction(recordability_1.validate, contextControl, copyControl.Id);
                                                    };
                                                })(),
                                                Label: $dyn.format($dyn.label("TaskRecorder_ContextMenuCopiedValuePlaceholder"), copyControl.ControlName, copyControl.Label),
                                            });
                                        };
                                        try {
                                            for (var copyControlArray_3 = __values(copyControlArray_1), copyControlArray_3_1 = copyControlArray_3.next(); !copyControlArray_3_1.done; copyControlArray_3_1 = copyControlArray_3.next()) {
                                                var copyControl = copyControlArray_3_1.value;
                                                _loop_2(copyControl);
                                            }
                                        }
                                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                        finally {
                                            try {
                                                if (copyControlArray_3_1 && !copyControlArray_3_1.done && (_b = copyControlArray_3.return)) _b.call(copyControlArray_3);
                                            }
                                            finally { if (e_2) throw e_2.error; }
                                        }
                                        recordOption.contextMenuOptions.push(validateOption);
                                    }
                                }
                                if (contextControl.AddInfoStep) {
                                    // This context control allows adding an info step
                                    var addInfoOption = {
                                        Command: function () {
                                            $dyn.callFunction(contextControl.AddInfoStep, contextControl, undefined, function () {
                                                // Open the pane on rountrip callback from server
                                                taskRecording.open();
                                            });
                                        },
                                        Enabled: true,
                                        Label: $dyn.label("TaskRecorder_ContextMenuAddInfoStep"),
                                    };
                                    recordOption.contextMenuOptions.push(addInfoOption);
                                }
                                // Broadcast the event to any subscriber
                                // used in ClientTaskRecorderFuzzOptionsJS.js
                                taskRecording.contextMenuOpen.raise({ RecordOption: recordOption, ContextControl: contextControl });
                                list.push(recordOption);
                            }
                        }
                    });
                }
            }
            taskRecording._handleServerRecordingStateChanged = _handleServerRecordingStateChanged;
        })(taskRecording = ax.taskRecording || (ax.taskRecording = {}));
    })(ax = $dyn.ax || ($dyn.ax = {}));
    $dyn.observe(ax.taskRecording.started, function (isStarted) {
        if (isStarted) {
            // Disable preview and save the state
            ax.taskRecording.disabledPreviewState = $dyn.flags.disablePreview;
            $dyn.flags.disablePreview = true;
        }
        else {
            // Restore the state before recording
            $dyn.flags.disablePreview = ax.taskRecording.disabledPreviewState;
        }
    });
})($dyn || ($dyn = {}));

//# sourceMappingURL=TaskRecording.js.map
